export default "__VITE_ASSET__471f8a34__"